module.exports = __webpack_public_path__ + "static/assets/5c540cafeb35fab1d8381f5f3f029536.png";